define('bindingHandlers/afterForEach',[
    'lib/knockout'
], function (ko) {
    'use strict';

    ko.bindingHandlers.afterForEach = {
        after: [
            'foreach'
        ],
        update: function (element, valueAccessor, allBindingsAccessor) {

            // I want to make sure this function accesses the foreach data array. This should make sure it updates with
            // the foreach, since bindings update independently now?
            if (allBindingsAccessor.has('foreach')) {
                ko.unwrap(allBindingsAccessor.get('foreach'));
            }

            // Invoke the callback.
            var handler = ko.unwrap(valueAccessor());
            if (typeof(handler) === 'function') {
                var containerElement;
                var firstChild = ko.virtualElements.firstChild(element);
                if (firstChild) {
                    containerElement = firstChild.parentNode;
                }
                handler(containerElement);
            }
        }
    };
    ko.virtualElements.allowedBindings.afterForEach = true;

    return ko.bindingHandlers.afterForEach;
});
